import { FlowerFaceType } from 'app/webview/pages/stats_profile/lib/types'
import { FlowerFaceHappy } from './FlowerFaceHappy'
import { FlowerFaceSleepy } from './FlowerFaceSleepy'

interface Props {
  type: FlowerFaceType
  color: string
}

export const FlowerFace = ({ type, color }: Props) => {
  switch (type) {
    case 'happy':
      return <FlowerFaceHappy color={color} />
    case 'sleepy':
      return <FlowerFaceSleepy color={color} />
    default:
      return <FlowerFaceHappy color={color} />
  }
}
